import cn from 'classnames';
import { type ButtonHTMLAttributes } from 'react';
import type React from 'react';
import styles from './styles.module.scss';

interface ToggleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isToggleOn?: boolean;
  onClick?: () => void;
  className?: string;
}

export const Toggle: React.FC<ToggleProps> = ({ isToggleOn, onClick, className }) => {
  return (
    <button
      className={cn(
        styles.toggle,
        {
          [styles.on]: isToggleOn,
          [styles.off]: !isToggleOn,
        },
        className
      )}
      onClick={onClick}
      type="button"
    >
      <div className={styles.toggle__circle} />
    </button>
  );
};
